module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._l((_vm.listItems), function(listItem, index) {
    return _c(_vm.itemComponent, {
      key: index,
      tag: "component",
      attrs: {
        "isModal": _vm.isModal,
        "item": listItem
      },
      on: {
        "item-clicked": _vm.onItemClicked
      }
    })
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66b9927f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/foundation/ui/controls/card-list/component.vue
// module id = 999
// module chunks = 2